import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';

import type { RoleDto } from '@/features/settings/roles/types';

import type {
  CompanyScopeItem,
  WorkPackageAssignInput,
  WorkPackageCreateInput,
  WorkPackageDto,
  WorkPackageUpdateInput,
} from './types';

export const listWorkPackages = async (): Promise<WorkPackageDto[]> => {
  const res = await apiClient.get<ApiSuccess<WorkPackageDto[]>>('/work-packages');
  return res.data.data ?? [];
};

export const createWorkPackage = async (body: WorkPackageCreateInput): Promise<WorkPackageDto> => {
  const res = await apiClient.post<ApiSuccess<WorkPackageDto>>('/work-packages', body);
  return res.data.data;
};

export const updateWorkPackage = async (
  id: string,
  body: WorkPackageUpdateInput,
): Promise<WorkPackageDto> => {
  const res = await apiClient.patch<ApiSuccess<WorkPackageDto>>(
    `/work-packages/${encodeURIComponent(id)}`,
    body,
  );
  return res.data.data;
};

export const assignWorkPackage = async (
  id: string,
  body: WorkPackageAssignInput,
): Promise<RoleDto> => {
  const res = await apiClient.post<ApiSuccess<RoleDto>>(
    `/work-packages/${encodeURIComponent(id)}/assign`,
    body,
  );
  return res.data.data;
};

export const getCompanyScope = async (companyId: string): Promise<CompanyScopeItem[]> => {
  const res = await apiClient.get<ApiSuccess<CompanyScopeItem[]>>(
    `/companies/${encodeURIComponent(companyId)}/work-package-scope`,
  );
  return res.data.data ?? [];
};

export const updateCompanyScope = async (
  companyId: string,
  items: { work_package_id: string; enabled: boolean }[],
): Promise<CompanyScopeItem[]> => {
  const res = await apiClient.put<ApiSuccess<CompanyScopeItem[]>>(
    `/companies/${encodeURIComponent(companyId)}/work-package-scope`,
    { items },
  );
  return res.data.data ?? [];
};
